import { type ReactNode, useState, useEffect } from 'react';
import { AuthContext, type UserCredentials } from '@entities/auth';
import { useLocalStorage } from '@shared/lib/hooks';

type AuthProviderProps = {
  children: ReactNode;
};

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [user, setUser] = useState<UserCredentials | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const { getItem } = useLocalStorage();

  useEffect(() => {
    //Grab from localStorage
    const userFromStorage = getItem('user');
    setLoading(false);
    //If we have a userSession from storage set it as the state
    if (userFromStorage && userFromStorage.length) {
      const userSessionParsed = JSON.parse(userFromStorage);
      setUser(userSessionParsed);
    }
  }, [loading]);

  return (
    <AuthContext.Provider value={{ user, setUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
